export default __webpack_public_path__ + "static/media/bg-for-old-design_02.27bade22.svg";